import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreRoomStateUPRNote,
} from '../firestore/RoomStateUPRNote/schema'
import type { FirebaseRepository } from './FirebaseRepository'

export class RoomStateUPRNote extends ObservableModelWithDecorators<FirestoreRoomStateUPRNote> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreRoomStateUPRNote>
  ) {
    super(repository, doc)
    makeObservable(this)
  }
}
